import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Interior Design",
  "Modular Kitchens",
  "Custom Furniture",
  "Turnkey Execution",
  "Modular Homes",
  "Kitchen Remodeling",
  "Woodworking",
];

export default function MarqueeRibbon() {
  return (
    <div data-testid="services-marquee" className="border-y border-line bg-sand py-4">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="px-8 font-serif text-xl italic tracking-tight text-ink/70 md:text-2xl">
              {item}
            </span>
            <Asterisk size={16} className="text-terra" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
